<template>
  <section>
    <tab-container tabName="User Information" :isTabOpened="isTabOpened" @toggleTab="(toOpen)=>{toggleTab(toOpen)}">
      <section class="space-y-4">
        <div v-if="!editedUserInfo.icon.isSaving" @click="toggleIconTab()" class="bg-purple-600 rounded-full text-white w-28 h-28 mx-auto flex flex-col text-center overflow-hidden justify-between ring-4 relative ring-purple-300" :class="[isOnOwnUserInfo ? 'pop-click' : '']">
          <div class="flex h-full">
            <img :src="editedUserInfo.icon.value" alt="User Icon">
          </div>
          <div v-if="isOnOwnUserInfo"  class="bg-purple-500 flex absolute z-20 bottom-0 w-full opacity-75 py-1">
            <h6 class="text-xl capitalize m-auto leading-3">
              <ion-icon name="create"></ion-icon>
            </h6>
          </div>
        </div>
        <div v-else>
          <google-loader widthClass="w-16"></google-loader>
        </div>

        <div v-if="!editedUserInfo.username.isEditing" @click="toggleEditUsername(true)" class="font-bold text-purple-600 text-center flex space-x-1 justify-center  p-1 rounded-md w-max mx-auto transition-colors" :class="[isOnOwnUserInfo ? 'hover:bg-purple-50  pop-click' : '']">
          <h3 class="text-xl"> {{editedUserInfo.username.value}} </h3>
          <span v-if="isOnOwnUserInfo">
            <ion-icon class="text-xl opacity-70 mt-0.5" name="pencil"></ion-icon>
          </span>
        </div>
        <div v-else >

          <div v-if="!editedUserInfo.username.isSaving" class="flex space-x-3 mx-auto justify-center">
            
            <section class="w-full max-w-xs">
              <div class="flex justify-between">
                <label class="text-xs font-bold" :class="[{ 'text-purple-700' : editedUserInfo.username.isValidated},'text-red-700']" for="user-name">Username</label>
                <h6 v-if="editedUserInfo.username.value !== undefined" class="text-xs font-bold" :class="[{ 'text-purple-700' : editedUserInfo.username.isValidated},'text-red-700']" > {{editedUserInfo.username.value.length + '/' + editedUserInfo.username.maxValue }}</h6>
              </div>
              <input @keyup.enter="saveEditedUserName()" type="text" class="text-input-default" placeholder="Enter your new username" v-model="editedUserInfo.username.value" :class="[{ 'border-purple-700' : editedUserInfo.username.isValidated},'border-red-700']" :maxlength="editedUserInfo.username.maxValue" >

              <h6 v-if="!editedUserInfo.username.isValidated" class="text-red-600 text-xs font-bold absolute">{{editedUserInfo.username.errorMessage}}</h6>
            </section>

            <div class="flex">
               <h6 @click="saveEditedUserName()" class="btn-default px-2 w-max mt-auto">Save</h6>
            </div>
            <div class="flex">
              <h6 class="text-gray-500 hover:underline flex mt-auto py-2">
                <span @click="toggleEditUsername(false)"  class="m-auto pop-click">Cancel</span>
              </h6>
            </div>
          </div>
          <div v-else>
            <google-loader widthClass="w-12"></google-loader>
          </div>

        </div>

        <div v-if="!isOnOwnUserInfo" class="mt-20 space-y-3">
          <h6 class="text-xs text-purple-500 font-bold uppercase">Joined Chat Rooms</h6>

          <div>
            <chat-room-card  v-for="(room,key) in joinedChatRooms" :key="key" class="m-2 inline-block w-full max-w-xs" :chatRoom="room" :chatRoomId="key" @joinChatRoom="()=>{ $emit('joinChatRoom',key) }"  @errorIcon="()=>{ $emit('errorIcon',key) }" @setChatRoomInfo="(room,key,isAlreadyMember)=>{ $emit('setChatRoomInfo',room,key,isAlreadyMember)}" :isAlreadyMember="loggedInUsersChatRoomIds.includes(key)" ></chat-room-card>
          </div>

          <div>
            <h6 @click="showHiddenJoinedChatRooms" v-if="Object.keys(hiddenJoinedChatRooms).length > 0" class="btn-default text-xs w-max mx-auto px-3">
            View all {{editedUserInfo.username.value}}'s chat room 
            </h6>
          </div>
        </div>

        <div v-else class="mt-20 space-y-3">
          <h6 class="btn-default w-max px-4 ml-0" @click="isAdvanceSettingsOpen = !isAdvanceSettingsOpen">Advance Settings</h6>
          <transition name="slide-up">
            <div v-if="isAdvanceSettingsOpen">

              <div class="mt-5">
                <h6 class="text-red-600 text-md font-bold">Delete Account</h6>
                <section class="max-w-sm">
                  <label for="delete-reason" class="text-pink-600 text-xs font-bold">Reason of Account Deletion</label>
                  <textarea v-model="deleteAccountFeedback" id="delete-reason" type="text" class="text-input-default h-24 " placeholder="Let us know your thoughts to improve for the future."></textarea>
                  <h6 class="btn-default bg-red-400 hover:bg-red-500 mt-2" @click="deleteAccount">Permanently Delete Account</h6>
                </section>
              </div>

            </div>
          </transition>
        </div>

      </section>

    </tab-container>

    <tab-container :willCheckScroll="true"  tabName="Icon Selection" :isTabOpened="isIconTabOpened" @bottomScrolled="$refs.iconSelection.generateSeedIcon()" @toggleTab="(toOpen)=>{toggleIconTab(toOpen)}" >
      <icon-selection ref="iconSelection" :currentSelectedIcon="editedUserInfo.icon.value" @setNewIcon="(icon)=>{saveEditedIcon(icon)}" :isForChatRoom="false" ></icon-selection>
    </tab-container>

  </section>
</template>

<script>
import TabContainer from '@/components/TabContainer.vue';
import GoogleLoader from '@/components/GoogleLoader.vue';
import IconSelection from '@/components/IconSelection.vue';
import ChatRoomCard from '@/components/ChatRoomCard.vue';

import firebase from "firebase/app";

export default {
  data(){
    return {
      isTabOpened : false,
      isIconTabOpened : false,
      isOnOwnUserInfo : false,
      currentUsersData : {},
      loggedInUserJoinedChatRoomIds : [],
      joinedChatRoomIds : [],
      joinedChatRooms : {},
      hiddenJoinedChatRooms : {},
      chatRoomLimitToShow : 2,
      isAdvanceSettingsOpen : false,
      editedUserInfo : {
        "username" : {
          "value" : "",
          "isValidated" : true,
          "maxValue" : 50,
          "minValue" : 5,
          "errorMessage" : "",
          "isEditing" : false,
          "isSaving" : false,
          "originalValue" : ''
        },
        "icon" : {
          "value" : "",
          "isValidated" : true,
          "isSaving" : false
        }
      },
      deleteAccountFeedback : ''
    }
  },
  emits : ['joinChatRoom','errorIcon','setChatRoomInfo','signOut','deleteAccountModal'],
  components : {
    'tab-container' : TabContainer,
    'google-loader' : GoogleLoader,
    'icon-selection' : IconSelection,
    'chat-room-card' : ChatRoomCard,
  },
  props : {
    loggedInUsersChatRoomIds : Array,
  },
  methods : {
    toggleIconTab(toOpen = null){
      if(toOpen === null)toOpen = !this.isIconTabOpened;
      this.isIconTabOpened = toOpen;
    },
    saveEditedIcon(iconUrl){
      if(!iconUrl)return;
      this.editedUserInfo.isSaving = true;
      if(!this.currentUsersData)return;
      this.editedUserInfo.icon.isSaving = true;
      firebase.database().ref('users/' + this.currentUsersData.uid + '/icon').set(iconUrl)
      .then(()=>{
        this.editedUserInfo.icon.isSaving = false;
        this.editedUserInfo.icon.value = iconUrl;
        this.isIconTabOpened = false;
        
      })
      .catch((error)=>{
        console.log(error);
      }

      )
    },
    saveEditedUserName(){
      if(!this.editedUserInfo.username.value)return;
      if(!this.editedUserInfo.username.isValidated)return;
      if(!this.currentUsersData)return;
      this.editedUserInfo.username.isSaving = true;
      firebase.database().ref('users/' + this.currentUsersData.uid + '/username').set(this.editedUserInfo.username.value)
      .then(()=>{
        this.editedUserInfo.username.isSaving = false;
        this.editedUserInfo.username.isEditing = false;
      })
      .catch(()=>{
        this.editedUserInfo.username.value = this.editedUserInfo.username.originalValue;
      })
    },
    toggleEditUsername(toOpen = null ){
      if(!this.currentUsersData.uid)return;
      if(toOpen === null)return this.editedUserInfo.username.isEditing = !this.editedUserInfo.username.isEditing;
      this.editedUserInfo.username.isEditing = toOpen;
    },
    toggleTab(toOpen = null,costumizedUsersData = null,currentUsersData = null){
      if(toOpen !== null)this.isTabOpened = toOpen;
      
      if(!toOpen){
        this.joinedChatRooms = {};
      } 
      if(!costumizedUsersData)return;
      if(!currentUsersData)return;

      this.isOnOwnUserInfo = costumizedUsersData.uid === currentUsersData.uid && currentUsersData.uid;
      this.joinedChatRoomIds = Object.keys(costumizedUsersData.chatRoomsId);
      this.editedUserInfo.username.value = costumizedUsersData.username;
      this.editedUserInfo.username.originalValue = costumizedUsersData.username;

      this.editedUserInfo.icon.value = costumizedUsersData.icon;
      if(currentUsersData.chatRoomsId)this.loggedInUserJoinedChatRoomIds = Object.keys(currentUsersData.chatRoomsId);
      this.currentUsersData = currentUsersData;
    },
    getJoinedChatRooms(roomId,storeInHiddenChatRoom = false){
      firebase.database().ref().child("chatRooms").child(roomId).get().then( (snapshot)=>{
        if(!storeInHiddenChatRoom)return this.joinedChatRooms[snapshot.key] = snapshot.val();
        this.hiddenJoinedChatRooms[snapshot.key] = snapshot.val();
      });
    },
    showHiddenJoinedChatRooms(){
      for(let key in this.hiddenJoinedChatRooms){
        this.joinedChatRooms[key] = this.hiddenJoinedChatRooms[key];
        delete this.hiddenJoinedChatRooms[key];
      }
    },
    deleteAccount(){
      if(!this.currentUsersData.uid)return;

      const currentUserId = this.currentUsersData.uid;
      const deleteCallback = ()=>{
        const newFeedbackId = firebase.database().ref().child('feedback').push().key;
        firebase.database().ref().child("feedbacks/" + newFeedbackId).set({
          date : Date.now(),
          message : this.deleteAccountFeedback,
          senderId : currentUserId
        }).then( ()=>{
          firebase.database().ref().child("users/" + currentUserId).remove()
          .then(()=>{
            firebase.database().ref().child("registeredUsers/" + currentUserId).remove()
            .then(()=>{
              this.$emit('signOut');
            })
          });
        } );
      };
      this.$emit('deleteAccountModal',true,deleteCallback);
    }
  },
  computed : {
    usernameLength(){
      if(!this.editedUserInfo.username.value)return 0;
      return this.editedUserInfo.username.value.length;
    }
  },
  watch : {
    usernameLength(length){
      if(length <= 0){
        this.editedUserInfo.username.isValidated = false;
        this.editedUserInfo.username.errorMessage = "Username is Required";
        return;
      }else if(length <  this.editedUserInfo.username.minValue ){
        this.editedUserInfo.username.isValidated = false;
        this.editedUserInfo.username.errorMessage = "Username must be atleast "+ this.editedUserInfo.username.minValue+" characters.";
        return;
      }else if(length > this.editedUserInfo.username.maxValue){
        this.editedUserInfo.username.isValidated = false;
        this.editedUserInfo.username.errorMessage = "Username must be no more than "+this.editedUserInfo.username.maxValue+" characters.";
        return;
      }
      this.editedUserInfo.username.isValidated = true;
      this.editedUserInfo.username.errorMessage = "";
    },
    joinedChatRoomIds: {
      handler(roomIds){
        for(let i = 0; i < roomIds.length; i++){
          if( i  >= this.chatRoomLimitToShow ){
            this.getJoinedChatRooms(roomIds[i],true);
          }else{
            this.getJoinedChatRooms(roomIds[i]);
          }
        }
      },
      deep : true
      
    }
  }
}
</script>

<style>

</style>